// Google Tag Manager Event Tracking Utilities

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

// Inicializa o dataLayer se não existir
export const initDataLayer = () => {
  window.dataLayer = window.dataLayer || [];
};

// Push genérico de eventos
export const pushEvent = (eventName: string, eventData?: Record<string, unknown>) => {
  initDataLayer();
  window.dataLayer.push({
    event: eventName,
    ...eventData,
  });
};

// Evento específico para cliques no WhatsApp
export const trackWhatsAppClick = (location: string) => {
  pushEvent('WhatsApp Click', {
    event_category: 'Contact',
    event_label: location,
    click_location: location,
  });
};

// Evento para cliques em CTAs
export const trackCTAClick = (ctaName: string, section: string) => {
  pushEvent('cta_click', {
    event_category: 'CTA',
    cta_name: ctaName,
    section: section,
  });
};

// Evento para envio de formulário
export const trackFormSubmit = (formName: string) => {
  pushEvent('form_submit', {
    event_category: 'Lead',
    form_name: formName,
  });
};

// Evento principal de submit do formulário Solari Portas
export const trackSolariFormSubmit = (data: {
  clientType: string;
  regionGoiania: string;
  constructionStage: string;
  deadline: string;
  quantity: string;
}) => {
  pushEvent('form_submit_solari_portas', {
    form_name: 'LP Solari Portas',
    lead_type: data.clientType,
    region_goiania: data.regionGoiania,
    construction_stage: data.constructionStage,
    deadline: data.deadline,
    quantity: data.quantity,
    page_location: typeof window !== 'undefined' ? window.location.href : '',
  });
};

// Evento principal de CTA
export const trackCtaClick = (ctaName: string) => {
  pushEvent('cta_click', {
    cta_name: ctaName,
    page_location: typeof window !== 'undefined' ? window.location.href : '',
  });
};

// Evento de e-mail click
export const trackEmailClick = () => {
  pushEvent('email_click', {
    event_category: 'Contact',
    page_location: typeof window !== 'undefined' ? window.location.href : '',
  });
};

// Evento para cliques em links sociais
export const trackSocialClick = (platform: string) => {
  pushEvent('social_click', {
    event_category: 'Social',
    platform: platform,
  });
};

// Evento para cliques no telefone
export const trackPhoneClick = () => {
  pushEvent('phone_click', {
    event_category: 'Contact',
    event_label: 'Phone Call',
  });
};

// Evento para scroll até seções
export const trackSectionView = (sectionName: string) => {
  pushEvent('section_view', {
    event_category: 'Engagement',
    section_name: sectionName,
  });
};
